export const VERSION_INFO = {
    version: "V2.0",
    commit: "(4e64277e)",
    buildDate: "31-08-2026"
};